import React from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
import { LayoutProps } from '@/types/types';

type Props = LayoutProps & {
  children: React.ReactNode;
  size?: 'lg' | 'md' | 'small' | 'auto' | '700' | 'large';
  isNavBar?: boolean;
};

export const Container = ({ size, isNavBar = false, children }: Props) => {
  const className = classNames(styles.container, {
    [styles.large]: size === 'lg',
    [styles.medium]: size === 'md',
    [styles.size_700]: size === '700',
    [styles.small]: size === 'small',
    [styles.navBar]: isNavBar,
  });
  return <div className={className}>{children}</div>;
};
